import React, { useState } from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

function PreviousMood() {
  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);
  // const [searchTerm, setSearchTerm] = useState("");

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const dailyDate = new Date().toLocaleDateString("en-us", {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  const allMood = [
    [
      11,
      "I feel excited today, work was fine and i did achieve my set goal for the day",
    ],
    [
      12,
      "I feel happy today, though work did not go smoothly but i was able achieve some of my goal for the day",
    ],
    [
      13,
      "I feel sad, work was fine and i did achieve my set goal for the day but experience a teribble accident along the way",
    ],
    [
      14,
      "I feel sad, for the first time, i experience first hand curruption and how it is affecting our system. Honestly i felt cheated",
    ],
    [
      15,
      "I always feel excited on this day, excitement not because of work, not because of meeting my target goals, but beacause today is friday and tomorrow is a great opportunity for my personal development",
    ],
  ];

  return (
    <div>
      <Navbar />
      <div className="p-10 bg-[#D4DDCC]">
        <Link to="/moodtrack">
          <button className="flex gap-1 px-4 py-2 rounded-xl w-fit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            Back
          </button>
        </Link>

        <h3 className="flex mt-4 item-center justify-center uppercase text-[#295700] text-4xl font-bold">
          Recent Mood
        </h3>

        <div className="p-20 w-full">
          {allMood.map((each_post) => {
            return (
              <div className="flex items-start gap-20 mb-8 border-b-2 boder-gray-300">
                <div className="h-[100%] flex items-center flex-col">
                  <p>😩</p>
                </div>
                <div className="">
                  <h4 className="font-bold">{dailyDate}</h4>
                  <p className="py-3">{each_post[1]}</p>
                </div>
              </div>
            );
          })}
          <div className="flex items-center justify-center gap-10 mt-4">
            <button
              // onClick={handlePrev}
              className="py-1 px-4 bg-[#295700] text-white font-medium hover:bg-white hover:text-[#295700] border-2 border-[#295700]"
            >
              Prev
            </button>
            <button
              // onClick={handleNext}
              className="py-1 px-4 bg-[#295700] text-white font-medium hover:bg-white hover:text-[#295700] border-2 border-[#295700]"
            >
              Next
            </button>
          </div>
          <p className="text-sm text-center text-gray-800 mt-4">
            Page {currentPage} out of 7
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PreviousMood;
